/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {},
  addDataLayer = addDataLayer || {};

(function () {
  'use strict';
  
  /**
   * Вид для popup с корабликом (акция)
   */
  app.SalePopupView = app.View.extend({
    el: '.sale_popup-wrapper',
    
    events: {
      'click': 'closeSalePopup',
      'click .sale_popup': function (e) {
        e.stopPropagation();
      },
      'click .sale_popup-close, .sale_popup-button': 'closeSalePopup'
    },
    
    run: function () {
      if (!app.helpers.CookieHelper.getCookie('isSalePopupClosed') && !app.isMobile) {
        /**
         * Если пользователь новый, показываем попап через 5 переходов, если старый - через 3.
         * @type {number}
         */
        var viewNeeded = addDataLayer.client_type === 'new' ? 5 : 3,
          counter = app.helpers.CookieHelper.getCookie('viewCounter');
        if (!counter) {
          counter = 1;
          this.setCounterCookie(counter);
        } else {
          counter = parseInt(counter, 10);
          counter++;
          this.setCounterCookie(counter);
          if (counter === viewNeeded) {
            this.$el.fadeIn();
          }
        }
      }
    },
    
    closeSalePopup: function () {
      this.$el.fadeOut();
      this.setCounterCookie(0, -1);
      app.helpers.CookieHelper.setCookie('isSalePopupClosed', 1, {
        domain: '.' + app.helpers.UrlHelper.getDomain(),
        path: '/',
        expires: 31536000
      });
    },
    /**
     * Метод для сохранения в куки количества переходов.
     * @param counter
     * @param expires
     */
    setCounterCookie: function (counter, expires) {
      expires = expires || 31536000;
      app.helpers.CookieHelper.setCookie('viewCounter', counter, {
        domain: '.' + app.helpers.UrlHelper.getDomain(),
        path: '/',
        expires: expires
      });
    }
  });
  
})();

}.call(window));